import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    IconButton,
    Typography,
    Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon } from '../../../vectors/index';
import DeleteIcon2 from '@mui/icons-material/Delete';
import { useDeleteEmployer } from '../hooks/useDeleteEmployer';
import { useDeleteApplicant } from '../hooks/useDeleteApplicant';
import { useDeleteAdminUser } from '../hooks/useDeleteAdminUser';
import { useDeleteEnterprise } from '../hooks/useDeleteEnterprise';

type EmployerDeleteModalProps = {
    handleClose: () => void;
    item: any;
    applicant?: boolean;
    admin?: boolean;
};

const EmployerDeleteModal: FC<EmployerDeleteModalProps> = ({
    handleClose,
    applicant,
    item,
    admin,
}) => {
    const [alertText, setAlertText] = useState<string>('');
    const { deleteEmployer, isdeleteEmployerLoading } = useDeleteEmployer({
        setAlertText,
    });
    const { deleteApplicant, isdeleteApplicantLoading } = useDeleteApplicant({
        setAlertText,
    });
    const { deleteEnterprise, isdeleteEnterpriseLoading } = useDeleteEnterprise({
        setAlertText,
    });
    const { deleteAdminUser, isdeleteingAdminUserLoading } = useDeleteAdminUser({
        setAlertText,
    });

    const handleDelete = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                handleClose();
            },
        };

        if (applicant) {
            deleteApplicant({ user_id: item?.id }, options);
        } else if (admin) {
            deleteAdminUser({ admin_id: item?.id }, options);
        } else if (item?.enterprise) {
            deleteEnterprise({ user_id: item?.id }, options);
        } else {
            deleteEmployer({ user_id: item?.id }, options);
        }
    };

    return (
        <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <IconButton
                    sx={{ position: 'absolute', top: 5, right: 5 }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
                <br />
                <DeleteIcon />
                <br />
                <Typography variant="h4" m={2}>
                    Are you sure you would like to delete? this can’t be undone.
                </Typography>
            </DialogTitle>
            <DialogContent>
                {alertText && (
                    <Alert sx={{ margin: '10px 0' }} severity="error">
                        {alertText}
                    </Alert>
                )}
                <LoadingButton
                    loading={
                        isdeleteEmployerLoading ||
                        isdeleteApplicantLoading ||
                        isdeleteEnterpriseLoading ||
                        isdeleteingAdminUserLoading
                    }
                    disabled={
                        isdeleteEmployerLoading ||
                        isdeleteApplicantLoading ||
                        isdeleteEnterpriseLoading ||
                        isdeleteingAdminUserLoading
                    }
                    fullWidth
                    startIcon={<DeleteIcon2 />}
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                      sx={{ marginTop: 2, marginBottom: 2 }}
                >
                    Delete
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default EmployerDeleteModal;
